import { render, staticRenderFns } from "./ProductPageLayout.vue?vue&type=template&id=fc41b628&scoped=true&"
import script from "./ProductPageLayout.vue?vue&type=script&lang=js&"
export * from "./ProductPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageLayout.vue?vue&type=style&index=0&id=fc41b628&prod&lang=scss&scoped=true&"
import style1 from "./ProductPageLayout.vue?vue&type=style&index=1&id=fc41b628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc41b628",
  null
  
)

export default component.exports